var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('MapBoxPopup',{attrs:{"show":!!_vm.coordinates,"coordinates":_vm.coordinates,"offset":[0,-15]},on:{"close":_vm.handleClose}},[_c('div',{domProps:{"textContent":_vm._s(_vm.$t('map.newLocation'))}})])}
var staticRenderFns = []

export { render, staticRenderFns }